/* eslint-disable react/react-in-jsx-scope */
import {
  // BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import { AsideSupport } from '../../_layout/aside-support';

import { Academy } from './academy';
import { Bookstore } from './bookstore';
import { Cooperative } from './cooperative';
import { Return } from './return';

export function InformationMain() {
  return (
    <Switch>
      <>
        {/* 게시판관련 */}
        <div className="scroll">
          <main className="sub bookstore wrapper">
            <AsideSupport />
            <Route path="/info/bookstore" component={Bookstore} />
            <Route path="/info/cooperative" component={Cooperative} />
            <Route path="/info/academy" component={Academy} />
            <Route path="/info/returns" component={Return} />
          </main>
        </div>
      </>
    </Switch>
  );
}
